export const replaceImageDimensions = (html, size = 110) => {
  if (!html || typeof html !== 'string') {
    return html;
  }

  return html.replace(/<(img)([^>]*)>/gi, (match, tagName, attributes) => {
    // Replace width=<number> or w=<number> and height=<number> or h=<number>
    const updatedAttributes = attributes
      .replace(/\b(width)=\d+/gi, `$1=${size}`)
      .replace(/\b(w)=\d+/g, `$1=${size}`)
      .replace(/\b(height)=\d+/gi, `$1=${size}`)
      .replace(/\b(h)=\d+/g, `$1=${size}`);
    return `<${tagName}${updatedAttributes}>`;
  });
};
